export default {
  label: '采矿工程师',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '采矿工程师是矿山开采和管理领域的专业人才，负责规划、设计和监督矿山设施的开发与运营',
          id: '0-1-1',
        }
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '设计矿山开发方案，研究矿床地质情况，制定采矿方法和技术路线',
          id: '0-2-1',
        },
        {
          label: '组织矿山生产、设备运行和维护，确保生产效率和安全',
          id: '0-2-2'
        },
        {
          label: '制定矿山环保措施，优化资源利用和经济效益',
          id: '0-2-3'
        },
        {
          label: '审查矿山开发利用方案，编制生产计划，管理矿山权益和证照',
          id: '0-2-4'
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '拥有采矿工程相关学历背景，熟悉矿山开采设计及安全管理',
          id: '0-3-1',
        },
        {
          label: '具备良好的心理素质和职业道德，能够承受工作压力',
          id: '0-3-2',
        }
      ],
    },
    {
      label: '薪资水平',
      id: '0-4',
      children: [
        {
          label: '3年工作经验：10000元左右',
          id: '0-4-1',
        }
      ],
    },
    {
      label: '晋升方向',
      id: '0-5',
      children: [
        {
          label: '生产技术主管',
          id: '0-5-1',
        }
      ],
    }
  ],
};